var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2296 4.16634C12.0269 4.73977 11.9167 5.35684 11.9167 5.99967H4.58333V18.833H17.4167V11.4997C18.0595 11.4997 18.6765 11.3894 19.25 11.1867V19.7497C19.25 20.2559 18.8396 20.6663 18.3333 20.6663H3.66667C3.16041 20.6663 2.75 20.2559 2.75 19.7497V5.08301C2.75 4.57675 3.16041 4.16634 3.66667 4.16634H12.2296ZM17.4167 7.83301C18.4292 7.83301 19.25 7.0122 19.25 5.99967C19.25 4.98715 18.4292 4.16634 17.4167 4.16634C16.4041 4.16634 15.5833 4.98715 15.5833 5.99967C15.5833 7.0122 16.4041 7.83301 17.4167 7.83301ZM17.4167 9.66634C15.3917 9.66634 13.75 8.02472 13.75 5.99967C13.75 3.97463 15.3917 2.33301 17.4167 2.33301C19.4417 2.33301 21.0833 3.97463 21.0833 5.99967C21.0833 8.02472 19.4417 9.66634 17.4167 9.66634Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushNotificationsIcon);
export default __webpack_public_path__ + "static/media/push-notifications-icon.5e09755ea65cc79ccf2f262f90da367f.svg";
export { ForwardRef as ReactComponent };